var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownloadFile = function SvgIconDownloadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F26",
    fillOpacity: 0.2,
    d: "M15.5 23.5a8 8 0 1 0 16 0 8 8 0 0 0-16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.404,
    d: "M12.516 32H1.391A1.391 1.391 0 0 1 0 30.609V1.39C0 .623.623 0 1.39 0h18.497c.37-.002.725.143.987.404l5.16 5.161c.26.263.405.618.403.988v4.577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M9.749 9.385a1.05 1.05 0 1 1-1.044 1.157l-.006-.107.006-.108a1.05 1.05 0 0 1 1.044-.942zm0 3.478a1.05 1.05 0 1 1-1.044 1.157l-.006-.107.006-.107c.054-.53.5-.943 1.044-.943zm0 3.479a1.05 1.05 0 1 1-1.044 1.157l-.006-.108.006-.107c.054-.53.5-.942 1.044-.942zm0 3.478a1.05 1.05 0 1 1-1.044 1.157l-.006-.107.006-.108a1.05 1.05 0 0 1 1.044-.942zm0 3.478a1.05 1.05 0 1 1-1.044 1.157l-.006-.107.006-.107c.054-.53.5-.943 1.044-.943zm0 3.562a1.05 1.05 0 1 1-1.044 1.157l-.006-.107.006-.108a1.05 1.05 0 0 1 1.044-.942z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.404,
    d: "M11.835 5.023a2.06 2.06 0 0 1-.5 1.614 2.113 2.113 0 0 1-3.144 0 2.06 2.06 0 0 1-.528-1.614L8.177 0h2.963l.695 5.023z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.656,
    cy: 23.652,
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.404,
    rx: 8.344,
    ry: 8.348
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.404,
    d: "M23.656 19.478v8.348m0 0-3.129-3.13m3.129 3.13 3.129-3.13"
  }))));
};
export default SvgIconDownloadFile;